import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

import { FirebaseService } from '../../services/firebase.service';

@Component({
  selector    : 'new-list-recipe',
  templateUrl : 'new-list-recipe.html',
  styleUrls   : [ 'new-list-recipe.scss' ]
})

export class NewListRecipeComponent implements OnInit {
  @Input() isList : boolean;

  itemName          : string;
  titleCaseItemName : string;
  newListRecipe     : string;

  constructor(
    public  firebaseService : FirebaseService,
    private router          : Router,
  ) {}

  ngOnInit() : void {
    this.itemName          = this.isList ? 'list' : 'recipe';
    this.titleCaseItemName = this.isList ? 'List' : 'Recipe';
  }

  save() : void {
  	this.firebaseService.createListRecipe(this.newListRecipe, this.isList)
      .then(response => this.router.navigate([this.itemName, response]));
  }
}


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-dev/src/app/components/new-list-recipe/new-list-recipe.ts